import pegasus from "../../assets/scripts/global/01-pegasus";

/**
 * allModals
 *
 * Component code for creating all modals on the page
 *
 * @since  2.0.0
 */
window.modalStack = []; // Global stack for managing modals

window.allModals = () => {
    return {
        init() {
            const _this = this;
            const modalSkeleton = pegasus.stringToHTML(
                document.getElementById("Modal__Skeleton").innerHTML
            );
            const modalLinks = _this.createModalLinks(
                document.querySelectorAll("[data-pegasus-modal]")
            );

            modalLinks.forEach((link, index) => {
                const modal = modalSkeleton.cloneNode(true);

                let cssClass = "Modal",
                    modalNav;

                //check for classes to add
                if (link.dataset.pegasusModal.length) {
                    cssClass += " " + link.dataset.pegasusModal;

                    //if nav specified
                    if (link.dataset.pegasusModal.includes("Modal--with-nav")) {
                        modalNav = _this.buildModalNav(index, modalLinks);

                        if (modalNav) {
                            modal
                                .querySelector(".Modal__navigation")
                                .append(modalNav);
                        }
                    }
                }

                //setup classes and id
                modal.className = cssClass;
                modal.id = link.dataset.pegasusModalId;

                //append modal template to page if it does not already exist
                if (!document.getElementById(link.dataset.pegasusModalId)) {
                    document.body.append(modal);
                }

               
            });

            window.modal = this;
        },

        doesLinkAlreadyExist(link, linksArray) {
            return linksArray.find((element) => element.href === link.href);
        },

        createModalLinks(links) {
            const _this = this;
            const modalLinks = [];

            if (links.length) {
                links.forEach((link, index) => {
                    // Add ?modal=yes query string to url, so head and foot are removed from fetched page
                    const href = new URL(link.href);
                    href.search = "?modal=yes";
                    link.href = href;

                    const existingLink = _this.doesLinkAlreadyExist(
                        link,
                        modalLinks
                    );

                    //check for existing link and copy id if true
                    if (existingLink) {
                        link.setAttribute(
                            "data-pegasus-modal-id",
                            existingLink.dataset.pegasusModalId
                        );
                    } else {
                        link.setAttribute(
                            "data-pegasus-modal-id",
                            `modal-${index}`
                        );
                    }

                    //if there are 5 or more modals, add 'click' to load more
                   
                    link.addEventListener("click", (e) => {
                        e.preventDefault();
                        _this.loadModalContent(
                            link.href,
                            link.dataset.pegasusModalId
                        );
                    });

                    //add event to emit 'modalopen' event for specified modal
                    link.addEventListener("click", _this.emitModalOpen);

                    //check we're not adding existing links.
                    if (!existingLink) modalLinks.push(link);
                });
            }

            return modalLinks;
        },

        emitModalOpen(e) {
            e.preventDefault();

            const modalID = e.currentTarget.dataset.pegasusModalId;
            const myEvent = new CustomEvent("modalopen", {
                detail: { modalID },
            });

            window.dispatchEvent(myEvent);
        },

        buildModalNav(currentIndex, allLinksArray) {
            const _this = this;

            let prevLinkHTML, nextLinkHTML;

            //check if we're at the start or end
            let prevLink =
                currentIndex > 0 ? allLinksArray[currentIndex - 1] : "";
            let nextLink =
                currentIndex < allLinksArray.length - 1
                    ? allLinksArray[currentIndex + 1]
                    : "";

            //check if links are modals with navs
            if (prevLink !== "")
                prevLink = prevLink.dataset.pegasusModal.includes(
                    "Modal--with-nav"
                )
                    ? prevLink
                    : "";
            if (nextLink !== "")
                nextLink = nextLink.dataset.pegasusModal.includes(
                    "Modal--with-nav"
                )
                    ? nextLink
                    : "";

            if (prevLink !== "") {
                const target = prevLink.dataset.pegasusModalId,
                    href = new URL(prevLink.href);

                href.search = "?modal=yes";

                prevLinkHTML = `<a href="${href}" class="prev-link arrow-btn" data-pegasus-modal-id="${target}"></a>`;
            } else {
                prevLinkHTML = `<span class="prev-link arrow-btn -disabled"></span>`;
            }

            if (nextLink !== "") {
                const target = nextLink.dataset.pegasusModalId,
                    href = new URL(nextLink.href);

                href.search = "?modal=yes";

                nextLinkHTML = `<a href="${href}" class="next-link arrow-btn" data-pegasus-modal-id="${target}"></a>`;
            } else {
                nextLinkHTML = `<span class="next-link arrow-btn -disabled"></span>`;
            }

            //create modalNav DOM element
            const modalNav = pegasus.stringToHTML(
                `<div class="links">${prevLinkHTML} ${nextLinkHTML}</div>`
            );

            //set up modal open and ajax events on modal nav links
            modalNav
                .querySelectorAll("[data-pegasus-modal-id]")
                .forEach((link) => {
                    link.addEventListener("click", _this.emitModalOpen);

                    link.addEventListener("click", (e) => {
                        e.preventDefault();
                        _this.loadModalContent(
                            link.href,
                            link.dataset.pegasusModalId
                        );
                    });
                });

            return modalNav;
        },
        loadModalContent(href, modalID) {
            pegasus
                .fetchContent(href)
                .then((resp) => {
                    if (!resp.ok) throw Error(resp.statusText);

                    return resp.text();
                })
                .then((htmlResponse) => {
                    const modalHTML = htmlResponse;

                    const modalBody = document.querySelector(
                        `#${modalID} .Modal__body`
                    );

                    modalBody.innerHTML = modalHTML;
                })
                .then(() => {
                    const formElement = document.querySelector(`#${modalID} .hbspt-form`);
                    const formScript = formElement?.previousElementSibling;
                
                    if (formScript && !formScript.hasAttribute('data-hubspot-rendered')) {
                        // Use a timeout to allow the DOM to be fully ready before reinitializing the form
                        setTimeout(() => {
                            // Reinitialize the HubSpot form by running the script again
                            eval(formScript.innerHTML);
                            formScript.setAttribute('data-hubspot-rendered', 'true');
                            console.log('HubSpot form reinitialized');
                        }, 100); // Adjust the delay if necessary
                    }
                
                    // Reinit other forms if applicable (e.g., Contact Form 7)
                    if (typeof wpcf7 !== "undefined" && wpcf7 !== null) {
                        const cf7Forms = document.querySelectorAll(`#${modalID} .wpcf7 > form`);
                        if (cf7Forms.length) {
                            cf7Forms.forEach((form) => wpcf7.init(form));
                        }
                    }
                })                
                .catch((error) => {
                    console.error(error);

                    const modalBody = document.querySelector(
                            `#${modalID} .Modal__body`
                        ),
                        errorContainer =
                            modalBody.querySelector(".Modal__error");

                    if (
                        typeof errorContainer === "undefined" ||
                        errorContainer === null
                    )
                        return;

                    errorContainer.classList.remove("hidden");
                })
                .finally(() => {
                    if (document.lazyLoadInstance) {
                        document.lazyLoadInstance.update();
                    }
                    window.dispatchEvent(new Event("resize"));
                    this.init();
                });
        },
    };
};

/**
 * singleModal
 *
 * Component code for a single modal
 *
 * @since  2.0.0
 */
window.singleModal = () => {
    return {
        open: false,

        handleModalOpen(evt) {
            // Only open the modal with the correct ID
            const modalID = evt.detail.modalID;

            if (this.$el.id === modalID) {
                document.body.classList.add("modal-open");

                // Track modal ID and push it onto the stack
                window.modalStack.push(modalID);

                this.open = true; // Set the current modal as open
            }
        },

        handleModalBack() {
            // Only close the topmost modal in the stack
            const modalID = window.modalStack.pop();
            this.open = false;
            
            if (this.$el.id === modalID) {
                this.open = false;
                document.body.classList.remove("modal-open");

                // Reopen the previous modal in the stack (if any)
                const previousModalID = window.modalStack[window.modalStack.length - 1];
                if (previousModalID) {
                    const previousModal = document.getElementById(previousModalID);
                    if (previousModal && previousModal.__x) {
                        previousModal.__x.$data.open = true;
                    }
                }
            }
        },

        handleModalClose() {
            // this.handleModalClose(); // Close the current modal and reopen the previous one
            this.open = false;
            document.body.classList.remove("modal-open");
        },
    };
};
